import { lazy, Suspense, useContext, useEffect, useRef } from "react";
import "./index.scss";
import { useState } from "react";
const AssessmentPreview = lazy(
  () =>
    import("../../components/Assessment/AssessmentPreview/AssessmentPreview"),
);

const TemplateLeftSide = lazy(
  () => import("./sections/AssessmentScope/TemplateLeftSide/TemplateLeftSide"),
);
import Head from "./sections/AssessmentScope/Head/Head";
import { setSessionStorageItem } from "../../utils/SessionStorageMethod/setSessionStorageItem";
import { getSessionStorageItem } from "../../utils/SessionStorageMethod/getSessionStorageItem";
import { removeSessionStorageItem } from "../../utils/SessionStorageMethod/removeSessionStorageItem";
import { AssessmentJsonContext } from "../../context/JsonContext/JsonContext";
import ComponentIds from "../../utils/Json/componentIds.json";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getAssessmentDetailsByAssessementId,
  getAssessmentTemplate,
  getIndustries,
  getRoleCentricRender,
  getScopeHierarchyList,
} from "../../service/Scope/Scope";
import {
  createAssessmentDraftJson,
  getCreateAssessmentDraftJson,
} from "../../service/DraftJson/DraftJson";
import { checkKeysInSessionStorage } from "../../utils/Common/checkKeysInSessionStorage";
import SetDraftJsonInSession from "./AssessmentDraftJson/SetDraftJsonInSession";
import { assessmentDraftJson } from "../../context/CreateAssessmentDraftJson/CreateAssessmentDraftJson";
import { Form, Formik } from "formik";
import {
  determinePageType,
  drafteditedformData,
  editedExistingformData,
  editedformData,
  initialScopeData,
  transformExistingTempalteData,
  addDisableCss,
  findValuesForKey,
  checkUniqueIdMatch,
  mergeSkills,
  getAssessmentPath,
  handleKeyPressSearch,
  scrollWindowTop,
} from "../../utils/Common/Constant";
import useDebounce from "../../utils/Hooks/useDebounce";
import {
  AssessmentButton,
  RightSidePanel,
  TemplateSearch,
} from "ui-components";
import { useTranslation } from "react-i18next";
import CustomModal from "../../components/CustomModal/CustomModal";
import CircleCrossIcon from "../../utils/Images/CircleCrossIcon";
import ShowAllTemplate from "../../components/Assessment/ShowAllTemplate/ShowAllTemplate";
import TestCaseWrongIcon from "../../utils/Images/TestCaseWrongIcon";
import Loader from "../../components/Loader/Loader";

const Assessment: React.FunctionComponent = () => {
  const { tempUniqueId } = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const templateRef = useRef(null);
  // to identify wheather it is created assessment or edited assessment
  const editedParams = new URLSearchParams(location.search).get("edited");
  const jobId = new URLSearchParams(location.search).get("jobId");
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  // Get current language
  const currentLanguage = i18n.language;
  const activeStep = determinePageType(pathname);
  const [existingTemplatePreview, setExistingTemplatePreview] = useState(
    getSessionStorageItem("existingPreview") || null,
  );
  const [templateLoading, setTemplateLoading] = useState(true);
  const [existingTemplateSearch, setExistingTemplateSearch] = useState(""); // search existing tempalte
  const searchExistingTemplate = useDebounce(
    existingTemplateSearch.trim(),
    700,
  );
  // TemplateLeftSide state
  const createTemplate = "EXISTING";
  const [existingTemplate, setExistingTemplate] = useState<any>(null);
  const [templateCurrentPage, setTemplateCurrentPage] = useState(1);
  const templateCurrentPageDebounced = useDebounce(
    templateCurrentPage.toString(),
    400,
  );
  const [loadMoreTemplate, setLoadMoreTemplate] = useState(false);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const renderRouteName = "template";
  const [industryList, setIndustryList] = useState<any>();
  const [isIndustryPrefilled, setIsIndustryPrefilled] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState<any>([]);
  const debounceSkillSearchValue = useDebounce(
    selectedIndustry?.label?.trim() ?? "",
    400,
  );
  const [hierarchyList, setHierarchyList] = useState<any>([]);
  const [isCompleteProfileModalOPen, setIsCompleteProfileModalOPen] =
    useState(false);
  const [loadMoreTemplateData, setLoadMoreTemplateData] = useState<any>([]); // For temporary storing existing template while loadmore
  const [isTemplatePreviewPopupOpen, setIsTemplatePreviewPopupOpen] =
    useState<any>({
      isPopupOpen: false,
      popupData: {},
    });
  const templatePageSize = 10;
  const navigate = useNavigate();
  const industriesSkillId = localStorage.getItem("industryId") ?? "";
  const userId = localStorage.getItem("companyId") ?? "";
  const tempUniqueIdBySession = localStorage.getItem("tempUniqueId") ?? null;
  const [hierarchyIds, setHierarchyIds] = useState([]);
  const hierarchyIdsDebounced = useDebounce(hierarchyIds.toString(), 400);
  const [hierarchyLoader, setHierarchyLoader] = useState(true);
  const [resetClick, setResetClick] = useState(false);
  const [highlightedId, setHighlightedId] = useState<string | null>(null);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const webTemplateId = location?.state?.templateID ?? false;
  const onReset = () => {
    setResetClick(true);
    setSelectedIds([]);
    setHighlightedId(null);
  };
  const { state, dispatch } = useContext(AssessmentJsonContext) ?? {
    state: {
      renderJson: {},
      count: 0,
    },
    dispatch: () => {},
  };
  useEffect(() => {
    industriesSkillId == "null" && setIsCompleteProfileModalOPen(true);
  }, []);
  useEffect(() => {
    (async () => {
      const getJsonData = await getRoleCentricRender(renderRouteName);
      dispatch({
        type: "UPDATE_CENTRIC_RENDER_JSON",
        payload: getJsonData,
      });
    })();
    const isKeyPresent = checkKeysInSessionStorage(
      ["existingPreview", "existingData", "Type", "titleHeadContent"],
      "any",
    );
    if (
      (!isKeyPresent && !editedParams) ||
      checkUniqueIdMatch(tempUniqueId, tempUniqueIdBySession)
    ) {
      // api call to set store value in session
      SetDraftJsonInSession(userId, tempUniqueId, pathname);
    }
    setSessionStorageItem("assessJobId", jobId);
  }, []);

  // this useEffect render when we search template
  const getTemplateApi = async () => {
    setTemplateLoading(true);
    const existingTemplateNew = await getAssessmentTemplate(
      searchExistingTemplate,
      templateCurrentPage,
      templatePageSize,
      hierarchyIds,
      hierarchyIds.length
        ? ""
        : selectedIndustry?.value
          ? selectedIndustry?.value
          : "",
    );
    const transformexistingTemplate = transformExistingTempalteData(
      existingTemplateNew?.data,
    );

    const totalLoaded =
      (templateCurrentPage - 1) * templatePageSize +
      existingTemplateNew?.data?.length;
    setTotalTemplates(existingTemplateNew?.totalCount);
    let updatedList = [];
    if (templateCurrentPage === 1) {
      // It's a new search, reset list
      updatedList = transformexistingTemplate;
    } else {
      // It's a load more, concatenate
      // do not append the duplicate data in the existing list
      updatedList = [
        ...loadMoreTemplateData,
        ...transformexistingTemplate.filter(
          (newItem) =>
            !loadMoreTemplateData.some(
              (existingItem: any) =>
                existingItem?.assessmentId === newItem?.assessmentId,
            ),
        ),
      ];
      setExistingTemplate(updatedList);
      setLoadMoreTemplate(totalLoaded < existingTemplateNew?.totalCount);
    }

    // Update all the relevant state using updatedList
    setLoadMoreTemplateData(updatedList);
    if (webTemplateId) {
      // work when we redirect from websites template
      const updateTemplate = updatedList?.filter((item: any) => {
        return item?.assessmentId === location?.state?.templateID;
      });
      const existing = mergeSkills(updateTemplate[0] ?? {});
      setExistingTemplatePreview(existing);
      setSessionStorageItem("existingData", existing);
      setSessionStorageItem("existingPreview", existing);
      setTimeout(() => {
        const newState = { ...location.state };
        delete newState.templateID;
        navigate(location.pathname, { state: newState, replace: true });
        window.location.reload();
      }, 100);
    }
    if (
      existingTemplateSearch ||
      hierarchyIds.length ||
      !existingTemplatePreview?.assessmentId ||
      resetClick
    ) {
      setExistingTemplate(updatedList);
      setLoadMoreTemplate(totalLoaded < existingTemplateNew?.totalCount);
    }
    setTemplateLoading(false);
  };
  useEffect(() => {
    getTemplateApi();
  }, [
    searchExistingTemplate,
    templateCurrentPageDebounced,
    hierarchyIdsDebounced,
    debounceSkillSearchValue,
    existingTemplatePreview?.assessmentId,
  ]);
  // this use effect will run when we have selected a template and show only one selected template when come base to this page again
  useEffect(() => {
    scrollWindowTop();
    if (existingTemplatePreview?.assessmentId) {
      setExistingTemplate([existingTemplatePreview]);
      setLoadMoreTemplate(false);
    }
  }, []);

  // Run this effect whenever the session storage is updated

  const existingPreview = getSessionStorageItem("existingPreview");

  // Check if the items exist before accessing their properties
  const existingPreviewAssessmentTitle = existingPreview?.assessmentTitle || 1;

  useEffect(() => {
    setExistingTemplatePreview(
      getSessionStorageItem("existingPreview") || null,
    );
  }, [existingPreviewAssessmentTitle]);

  // render when edited assessment
  useEffect(() => {
    (async () => {
      if (editedParams) {
        setSessionStorageItem("isAiEvaluation", true);
        const draftRes = await getCreateAssessmentDraftJson(
          userId,
          tempUniqueId,
        );
        if (
          Object.keys(draftRes?.data?.data).length > 0 &&
          (draftRes?.data?.data?.createAssessmentJson?.build?.assessmentSkill
            ?.length ||
            draftRes?.data?.data?.createAssessmentJson?.template
              ?.existingPreview?.length ||
            draftRes?.data?.data?.createAssessmentJson?.custom
              ?.AssessmentCustomQuestions)
        ) {
          drafteditedformData(draftRes?.data?.data);
        } else {
          const editedData = await getAssessmentDetailsByAssessementId(
            tempUniqueId ?? "",
          );
          setSessionStorageItem("isStoreEditedData", true);
          if (editedData?.data?.templateId) {
            const templateData = await getAssessmentDetailsByAssessementId(
              editedData?.data?.assessmentId ?? {},
            );
            const existingPreviewData = editedExistingformData(templateData);
            setExistingTemplate([existingPreviewData]);
            setLoadMoreTemplate(false);
            const existing = mergeSkills(existingPreviewData);
            setSessionStorageItem("existingPreview", existing);
            setSessionStorageItem("existingData", existingPreviewData);
            setExistingTemplatePreview(existingPreviewData);
            editedformData(editedData);
          } else {
            const skills = editedData?.data?.assessmentSkills?.map(
              (item: any) => {
                return { ...item, id: item.id ?? Math.random() };
              },
            );
            setSessionStorageItem("ownPreview", skills);
            editedformData(editedData);
          }
        }
      }
    })();
  }, []);

  // // to move to next page
  const handleNext = async (count: number) => {
    let nextStep;
    if (count != null && count != undefined && typeof count === "number") {
      nextStep = activeStep < 4 ? count : activeStep;
    } else {
      nextStep = activeStep < 4 ? activeStep + 1 : activeStep;
    }
    // if (activeStep < count) {
    await createAssessmentDraftJson(assessmentDraftJson(tempUniqueId));
    // }
    setSessionStorageItem("currentStep", nextStep);

    navigate(
      getAssessmentPath(
        nextStep,
        tempUniqueId,
        currentLanguage,
        editedParams,
        jobId,
      ),
    );
  };
  // to move to previous page
  const handlePrevious = (count: number) => {
    if (count != null && count != undefined && typeof count === "number") {
      setSessionStorageItem("currentStep", count);
      navigate(
        getAssessmentPath(
          count,
          tempUniqueId,
          currentLanguage,
          editedParams,
          jobId,
        ),
      );
    }
  };

  const onGoPress = () => {
    setIsCompleteProfileModalOPen(false);
    navigate(`/${currentLanguage}/create-profile`, {
      state: { editProfile: false },
    });
  };
  useEffect(() => {
    getIndustryType(selectedIndustry?.label ?? "");
  }, [debounceSkillSearchValue]);

  const getIndustryType = async (search: string) => {
    try {
      const industries: any = await getIndustries(search);
      if (industries?.status === 200) {
        const updateData = industries?.data
          ?.filter((item: any) => item?.isActive)
          ?.map((item: any) => ({
            value: item?.industriesId,
            label: item?.name,
          }));

        setIndustryList(updateData);

        if (!isIndustryPrefilled) {
          // After fetching industry list, set default from localStorage
          const industryId = localStorage.getItem("industryId");
          if (industryId) {
            const matchedIndustry = updateData.find(
              (item: any) => item.value === industryId,
            );
            if (matchedIndustry) {
              setSelectedIndustry(matchedIndustry);
            } else {
              setSelectedIndustry(updateData[0]);
            }
          } else {
            setSelectedIndustry(updateData[0]);
          }
          setIsIndustryPrefilled(true); // ✅ ensure only first-time setting
        }
      }
    } catch (error) {
      console.error("Error in getting industry type", error);
    }
  };
  useEffect(() => {
    if (selectedIndustry?.value) {
      getScopeHierarchyListApi(selectedIndustry?.value);
    }
  }, [debounceSkillSearchValue]);
  // getScopeHierarchyList
  const getScopeHierarchyListApi = async (industryId: string) => {
    setHierarchyLoader(true);
    try {
      const res = await getScopeHierarchyList(industryId);
      if (res?.status === 200) {
        setHierarchyList(res?.data);
      }
      setHierarchyLoader(false);
    } catch (error) {
      console.error(error);
      setHierarchyLoader(false);
    }
  };
  return (
    <Suspense>
      <Formik
        initialValues={initialScopeData}
        onSubmit={() => {
          // handleNext();
        }}
      >
        {({ errors, touched }) => {
          return (
            <Form>
              <div className="row">
                <div className="col-md-12">
                  <Head
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    currentStep={activeStep}
                    errors={errors}
                    touched={touched}
                  />
                </div>
              </div>
              <Suspense>
                <div
                  ref={templateRef}
                  className={`skillSec ${activeStep != 0 && "mt45"}`}
                >
                  <div className="row">
                    <div
                      className={`${addDisableCss(
                        findValuesForKey(
                          state?.renderJson,
                          "scope",
                          ComponentIds?.scope?.createTemplateKey,
                        ),
                      )}  col-md-3 `}
                    >
                      <TemplateLeftSide
                        createTemplate={createTemplate}
                        industryList={industryList}
                        selectedIndustry={selectedIndustry}
                        setSelectedIndustry={setSelectedIndustry}
                        hierarchyList={hierarchyList}
                        setHierarchyIds={setHierarchyIds}
                        hierarchyLoader={hierarchyLoader}
                        setTemplateCurrentPage={setTemplateCurrentPage}
                        templateRef={templateRef}
                        setTemplateLoading={setTemplateLoading}
                        onReset={onReset}
                        highlightedId={highlightedId}
                        setHighlightedId={setHighlightedId}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                      />
                    </div>
                    <div className="col-md-9 mb-3">
                      {activeStep === 0 && (
                        <div className="mb-3">
                          <TemplateSearch
                            onChange={(e) => {
                              setExistingTemplateSearch(e);
                              setTemplateCurrentPage(1);
                              if (e === "") {
                                setResetClick(true);
                              }
                            }}
                            placeholder={t(
                              "CREATE_ASSESSMENT.SEARCH_PLACEHOLDER",
                            )}
                            value={existingTemplateSearch}
                            handleKeyPress={handleKeyPressSearch}
                            iconName="searchList"
                          />
                        </div>
                      )}
                      <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
                        {
                          <div
                            className="langSelect"
                            onClick={() =>
                              setIsTemplatePreviewPopupOpen({
                                isPopupOpen: true,
                                popupData: existingTemplatePreview,
                              })
                            }
                          >
                            {existingTemplatePreview?.assessmentId && (
                              <div className="forModelLang">
                                <div className="langContent">
                                  <div className="skillTime">
                                    <span className="timeValue">
                                      {
                                        existingTemplatePreview?.timeLimit?.split(
                                          " ",
                                        )[0]
                                      }
                                    </span>
                                    <span className="minutesText">
                                      {t("GENERAL.MINS")}
                                    </span>
                                  </div>
                                  <div className="skillNameType">
                                    <div className="langName">
                                      {existingTemplatePreview?.assessmentTitle
                                        ? existingTemplatePreview?.assessmentTitle
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeSessionStorageItem("existingPreview");
                                    removeSessionStorageItem("existingData");
                                    setExistingTemplatePreview(null);
                                  }}
                                  className="crossBtn"
                                >
                                  <TestCaseWrongIcon />
                                </span>
                              </div>
                            )}
                          </div>
                        }
                        {totalTemplates ? (
                          <p className="totalContent">
                            {t("CREATE_ASSESSMENT.TOTAL_TEMPLATES")} :{" "}
                            {totalTemplates}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      <ShowAllTemplate
                        templateLoading={templateLoading || hierarchyLoader}
                        existingTemplate={existingTemplate}
                        addbtnCallBack={(data: any) => {
                          removeSessionStorageItem("existingPreview");
                          removeSessionStorageItem("ownPreview");
                          removeSessionStorageItem("existingData");
                          const existing = mergeSkills(data ?? {});
                          setSessionStorageItem("existingPreview", existing);
                          setSessionStorageItem("existingData", data);
                          setExistingTemplatePreview(data);
                        }}
                        existingTemplatePreview={existingTemplatePreview}
                        templateCurrentPage={templateCurrentPage}
                        setTemplateCurrentPage={setTemplateCurrentPage}
                        loadMoreTemplate={loadMoreTemplate}
                        removeCallBack={() => {
                          removeSessionStorageItem("existingPreview");
                          removeSessionStorageItem("existingData");
                          setExistingTemplatePreview(null);
                        }}
                        setIsTemplatePreviewPopupOpen={
                          setIsTemplatePreviewPopupOpen
                        }
                      />
                    </div>
                  </div>
                </div>
              </Suspense>
            </Form>
          );
        }}
      </Formik>
      {isCompleteProfileModalOPen && (
        <CustomModal
          show={isCompleteProfileModalOPen}
          isHeaderVisible={false}
          isFooterVisible={false}
          className="completeProfileModal"
        >
          <div
            onClick={() => setIsCompleteProfileModalOPen(false)}
            className="closeProfileModal"
          >
            <CircleCrossIcon />
          </div>
          <div>
            <p className="modalHeading">{t("GENERAL.COMPLETE_YOUR_PROFILE")}</p>
            <div className={"goBtnWrapper"}>
              <AssessmentButton className={"goBtn"} onClick={onGoPress}>
                <span>{t("GENERAL.GO")}</span>
              </AssessmentButton>
            </div>
          </div>
        </CustomModal>
      )}
      {isTemplatePreviewPopupOpen?.isPopupOpen && (
        <RightSidePanel
          show={isTemplatePreviewPopupOpen}
          handleClose={() => setIsTemplatePreviewPopupOpen(false)}
          title={isTemplatePreviewPopupOpen?.popupData?.assessmentTitle}
          className="rightSidePanelSection"
        >
          <div className="templatePreviewWrapper">
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <AssessmentPreview
                existingTemplatePreview={isTemplatePreviewPopupOpen?.popupData}
              />
            </Suspense>
          </div>
        </RightSidePanel>
      )}
    </Suspense>
  );
};

export default Assessment;
